import type { Entity } from '@cognitoforms/model.js';
import { Format } from '@cognitoforms/model.js';
import { personLabel } from '@cognitoforms/utils/avatar';

export class PersonLabelFormat extends Format<Entity> {
	constructor(private readonly labelFormat: Format<Entity>, private readonly emailFieldPath: string) {
		super(labelFormat.model, labelFormat.specifier);
	}

	get paths(): string[] {
		return [...this.labelFormat.paths, this.emailFieldPath];
	}

	convertToString(entry: Entity): string {
		return personLabel(this.labelFormat.convert(entry), entry.toString(`[${this.emailFieldPath}]`));
	}

	convertFromString(text: string) {
		return this.labelFormat.convertFromString(text);
	}
}
